<template>
  <PaymentGatewayStatistic :balance="summary.balance" :deposit="summary.totalDeposit" :deposit-count="summary.depositCount" :withdraw="summary.totalWithdraw" :withdraw-count="summary.withdrawCount" class="mt-4">
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <h3>
          {{ paymentGatewayInfo.name }}
          <span v-if="isMaster" class="small mr-1">({{ summary.agentName }}) </span>
          <b-button v-if="$allowPermission('agent:manage.bank-account')" class="d-inline-flex" size="sm" variant="secondary" @click.prevent="onClickSetting">
            <i class="uil-cog mr-1" /> <span>ตั้งค่า</span>
          </b-button>
          <b-button v-if="$allowPermission('agent:manage.bank-account')" class="d-inline-flex ml-1" size="sm" variant="info" @click.prevent="onClickBalance">
            <i class="uil-wallet mr-1" /> <span>ปรับยอดเครดิต</span>
          </b-button>
        </h3>
        <div id="payment-status" class="d-flex" style="gap: 8px">
          <div>
            <b class="mr-1">ฝาก:</b>
            <b-badge v-if="!paymentGatewayInfo.isAllowedDeposit" pill variant="light">ไม่รองรับ</b-badge>
            <b-badge v-else-if="summary.isDepositEnabled" pill variant="success">เปิดใช้งาน</b-badge>
            <b-badge v-else pill variant="danger">ปิดใช้งาน</b-badge>
          </div>
          <div>
            <b class="mr-1">ถอน:</b>
            <b-badge v-if="!paymentGatewayInfo.isAllowedWithdraw" pill variant="light">ไม่รองรับ</b-badge>
            <b-badge v-else-if="summary.isWithdrawEnabled" pill variant="success">เปิดใช้งาน</b-badge>
            <b-badge v-else pill variant="danger">ปิดใช้งาน</b-badge>
          </div>
          <div>
            <b class="mr-1">ดึงชื่อ:</b>
            <b-badge v-if="!paymentGatewayInfo.isAllowedVerifyAccount" pill variant="light">ไม่รองรับ</b-badge>
            <b-badge v-else-if="summary.isVerifyAccountEnabled" pill variant="success">เปิดใช้งาน</b-badge>
            <b-badge v-else pill variant="danger">ปิดใช้งาน</b-badge>
          </div>
          <div>
            <b class="mr-1">เช็คสลิป:</b>
            <b-badge v-if="!paymentGatewayInfo.isAllowedVerifySlip" pill variant="light">ไม่รองรับ</b-badge>
            <b-badge v-else-if="summary.isVerifySlipEnabled" pill variant="success">เปิดใช้งาน</b-badge>
            <b-badge v-else pill variant="danger">ปิดใช้งาน</b-badge>
          </div>
        </div>
      </div>
    </template>
  </PaymentGatewayStatistic>
</template>

<script>
import {PAYMENT_GATEWAY} from '@src/constants/payment-gateway';
import {mapGetters} from 'vuex';

export default {
  name: 'PaymentGatewayProviderStatistic',
  components: {
    PaymentGatewayStatistic: () => import('@components/payment-gateway/statistic'),
  },
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isMaster']),
    paymentGatewayInfo() {
      return PAYMENT_GATEWAY[this.summary.name]
    }
  },
  methods: {
    onClickSetting() {
      this.$emit('onClickSetting', this.summary.id)
    },
    onClickBalance() {
      this.$emit('onClickBalance', this.summary)
    }
  }
}
</script>

<style scoped>
#payment-status > div {
  display: flex;
  align-items: center;
}
</style>